import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CreateForm from "./CreateForm";
import UpdateForm from "./UpdateForm";
import { NEW } from "config/keywords";

const StudentFormPage = () => {
  const { id } = useParams();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    setIsUpdate(id !== NEW);
  }, [id]);

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      {isUpdate ? <UpdateForm /> : <CreateForm />}
    </section>
  );
};

export default StudentFormPage;
